(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mv-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mv-faq')) {
  customElements.define('mv-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('input[type="search"]');
      if (!input) return;
      this.querySelector('.mv-faq__search').hidden = false;
      const groups = [...this.querySelectorAll('.mv-faq__group')];
      const items = [...this.querySelectorAll('.mv-faq__item')];
      const searchable = new Map(items.map(item => [item, item.textContent.toLocaleLowerCase()]));
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        let count = 0;
        items.forEach(item => {
          item.hidden = !searchable.get(item).includes(query);
          if (!item.hidden) count++;
          item.open = Boolean(query) && !item.hidden;
        });
        groups.forEach(group => {
          group.hidden = ![...group.querySelectorAll('.mv-faq__item')].some(item => !item.hidden);
          const link = this.querySelector('a[href="#' + group.id + '"]');
          if (link) link.hidden = group.hidden;
        });
        this.querySelector('.mv-faq__empty').hidden = count > 0;
      });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.mv-faq__item');
        if (item) { input.value = ''; input.dispatchEvent(new Event('input')); item.open = true; }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
